import axios from 'axios';
import apiConfig from "./apiConfig";


const BaseApiCall = axios.create({
  baseURL: apiConfig.baseUrl,
  timeout: 100000,
});

BaseApiCall.interceptors.request.use((config) => {
  const lgusr = JSON.parse(sessionStorage.getItem('lgusr'));
  if (lgusr && lgusr.accessToken) {
    config.headers['Authorization'] = `Bearer ${lgusr.accessToken}`;
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
}, (error) => {
  // Error handling for request failures
  return Promise.reject(error);
});

BaseApiCall.interceptors.response.use(
  (response) => response,
  (error) => {

    const { status } = error.response;
    if (status === 401) {
      handleUnauthorized();
    }
    else {
      const errorMessages = {
        403: 'Forbidden: You do not have permission.',
        404: 'Resource not found.',
        500: 'Server error. Please try again later.',
      };
      console.log(errorMessages[status] || `API error: ${status}`);
    }
    return Promise.reject(error);
  }
);

function handleUnauthorized() {
  sessionStorage.removeItem("lgusr");
  window.location.href = "/login";
  alert("Unauthorized access, logging out...");
}

export default BaseApiCall;
